import { createSlice } from "@reduxjs/toolkit";
import {
  fetchUserOrders,
  placeOrder,
  raiseComplaintOrder,
  complaintOrders,
  fetchUserOrderByRoomId,
  cancelledOrders,
  deleteDraftOrder,
  fetchReferralDiscountEligibility,
  fetchLoyaltyProgress,
} from "../thunks/orderThunk";
import { orderStatus } from "../../constants/commonConstants";

const createOrderSlice = createSlice({
  name: "createOrder",

  initialState: {
    formData: {},
    formDataFiles: [],
    pendingPaymentOrderId: "",
    referralDiscount: {
      enabled: false,
      eligible: false,
      basePercent: 30,
      referralPercent: 0,
      totalPercent: 30,
    },
    loyaltyProgress: null,

    previousOderId: "",
    userOrders: {
      orders: [],
      pagination: {},
    },
    pendingOrders: {
      orders: [],
      pagination: {},
    },
    inProgressOrders: {
      orders: [],
      pagination: {}
    },
    complaintOrders: {
      orders: [],
      pagination: {},
    },
    cancelledOrders: {
      orders: [],
      pagination: {},
    },
  },
  reducers: {
    setFormDataGlobState(state, action) {
      state.formData = { ...state.formData, ...action.payload };
    },
    setFormDataFiles(state, action) {
      state.formDataFiles = action.payload;
    },
    setPendingPaymentOrderId(state, action) {
      state.pendingPaymentOrderId = action.payload;
    },
    clearCreateOrderDraft(state) {
      state.formData = {};
      state.formDataFiles = [];
      state.pendingPaymentOrderId = "";
    },
  },
  extraReducers: (builder) => {
    builder
      // Place order
      .addCase(placeOrder.fulfilled, (state, action) => {
        console.log(action.payload);
      })

      // Fetch user orders
      .addCase(fetchUserOrders.fulfilled, (state, action) => {
        const params = action.meta.arg;
        console.log("fetchUserOrders", action);
        if(params?.orderStatus === orderStatus.CANCELLED){
          // cancelled orders
          state.cancelledOrders.orders = action.payload.data?.data;
          state.cancelledOrders.pagination = action.payload.data?.pagination;
        }else if(params?.orderStatus === orderStatus.PENDING_PAYMENT){
          // pending orders (pending Payment)
          state.pendingOrders.orders = action.payload.data?.data
          state.pendingOrders.pagination = action.payload.data?.pagination
        
        }else if(params?.multipleOrderStatus){
          // in progress orders
          state.inProgressOrders.orders = action.payload.data?.data
          state.inProgressOrders.pagination = action.payload.data?.pagination

        }else{
          // all orders
          state.userOrders.orders = action.payload.data?.data;
          state.userOrders.pagination = action.payload.data?.pagination;
        }
      })

      // Raise complaint order
      .addCase(raiseComplaintOrder.fulfilled, (state, action) => {
        console.log(action.payload);
      })

      // Get User Raised Complaint Orders
      .addCase(complaintOrders.fulfilled, (state, action) => {
        console.log('complaintOrders', action.payload);
        state.complaintOrders.orders = action.payload.data?.data;
        state.complaintOrders.pagination = action.payload.data?.pagination;
      })

      // check if the order ID already exists
      .addCase(fetchUserOrderByRoomId.fulfilled, (state, action) => {
        state.previousOderId = action.payload.data?.id;
      })

      .addCase(deleteDraftOrder.fulfilled, (state, action) => {
        const deletedOrderId = action.payload?.data?._id;
        state.pendingOrders.orders = state.pendingOrders.orders.filter(
          (order) => order?._id !== deletedOrderId
        );
        if (state.pendingOrders.pagination?.totalDocuments > 0) {
          state.pendingOrders.pagination.totalDocuments -= 1;
        }
      })
      .addCase(fetchReferralDiscountEligibility.fulfilled, (state, action) => {
        state.referralDiscount = {
          ...state.referralDiscount,
          ...(action.payload?.data || {}),
        };
      })
      .addCase(fetchLoyaltyProgress.fulfilled, (state, action) => {
        state.loyaltyProgress = action.payload?.data || null;
      })

  },
});

export const { clearCreateOrderDraft, setFormDataGlobState, setFormDataFiles, setPendingPaymentOrderId } = createOrderSlice.actions;
export default createOrderSlice.reducer;
